import {
  Component,
  ChangeDetectionStrategy,
  model,
  signal,
  inject,
  DestroyRef,
} from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule } from "@angular/forms";
import { select, Store } from "@ngxs/store";
import { StudentService } from "@platform-app/app/core/api/services";
import { SetSecureSessionActive } from "@platform-app/app/core/auth/auth.actions";
import { AuthState } from "@platform-app/app/core/auth/auth.state";
import { ButtonModule } from "primeng/button";
import { CheckboxModule } from "primeng/checkbox";
import { DialogModule } from "primeng/dialog";
import { finalize } from "rxjs";

@Component({
  selector: "app-secure-session-dialog",
  standalone: true,
  imports: [DialogModule, CheckboxModule, ButtonModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./secure-session-dialog.component.html",
  styleUrl: "./secure-session-dialog.component.scss",
})
export class SecureSessionDialogComponent {
  private readonly store = inject(Store);
  private readonly studentService = inject(StudentService);
  private readonly destroyRef = inject(DestroyRef);

  visible = model.required<boolean>();

  currentUser = select(AuthState.user);

  dontAskLater = signal<boolean>(false);

  handleVisibilityChange(visible: boolean) {
    if (!visible && this.dontAskLater()) {
      this.markDialogAsHidden();
    }

    this.visible.set(visible);
  }

  enableAutoLogOut() {
    this.store
      .dispatch(new SetSecureSessionActive())
      .subscribe(() => this.handleVisibilityChange(false));
  }

  private markDialogAsHidden() {
    this.studentService
      .hideSecureSessionDialog({ id: this.currentUser()!.id })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.visible.set(false)),
      )
      .subscribe();
  }
}
